import React from 'react';
import ErrorModal from '../components/ErrorModal/ErrorModal';
import { ErrorStateContext, ErrorDispatchContext } from '../contexts/errorContext';
import { AppContext } from '../contexts/appContext';
import { PurchaseActionContext } from '../contexts/purchaseContext';
import ActionTypes from '../constants/actionTypes';
import { UserActionContext } from '../contexts/userContext';
import { History } from 'history';
import { getDepartmentIdHeader } from '../helpers/urlHelper';

interface ErrorModalContainerProps {
  submit?: () => {};
  history: History;
}

const ErrorModalContainer = ({ submit, history }: ErrorModalContainerProps) => {
  const { show, title, description, buttonTitle, cancelApplication } = React.useContext(ErrorStateContext);
  const dispatch = React.useContext(ErrorDispatchContext);
  const appContext = React.useContext(AppContext);
  const purchaseActionContext = React.useContext(PurchaseActionContext);
  const userActionContext = React.useContext(UserActionContext);

  const onSubmit = () => {
    submit?.();
    if (cancelApplication) {
      appContext.setIsActiveApplication(false);
      appContext.resetAppData();
      purchaseActionContext.reset();
      userActionContext.reset();
      const departmentHeader = getDepartmentIdHeader(history.location.search);

      window.history.replaceState({}, document.title, `${history.location.pathname}${departmentHeader}`);
      history.replace({ ...history.location, search: departmentHeader });
    }
    dispatch({ type: ActionTypes.ActionClearError });
  };

  return (
    <ErrorModal
      {...{
        isOpen: show,
        title,
        description,
        button: buttonTitle,
        submit: onSubmit,
      }}
    />
  );
};

export default ErrorModalContainer;
